import { Button, Paper, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
import { Fragment, useContext, useState } from "react";
import InputFiles from "react-input-files";
import { AuthContext } from "../../context/context";
import cotizador from "../../services/cotizador";
import useStyles from "./endosoPanelStyles";
import ResumenCotizacion from "./resumenCotizacion";
import TarifasSection from "./tarifasSection";

const EndosoPanel = ({
  grupo,
  grupoInfo,
  inicioVigencia,
  onCancelar,
  cancelando,
  onSolicitudCreada,
  setMessage,
  setShowMessage,
  onCotizado,
  cotizacionData,
  productos,
  cargandoProductos,
  errorProductos,
  onReintentarProductos,
  onEmitir,
  emitiendo,
  pasoTarifas,
  onContinuar,
  noSolicitudRecuperada,
}) => {
  const classes = useStyles();
  const { token } = useContext(AuthContext);
  const [subiendo, setSubiendo] = useState(false);
  const [cotizando, setCotizando] = useState(false);
  const [solicitud, setSolicitud] = useState(null);
  const [archivoNombre, setArchivoNombre] = useState("");
  const [cotizado, setCotizado] = useState(false);

  const handleArchivoSeleccionado = async (files, e) => {
    const file = files && files[0];
    if (e && e.target) e.target.value = "";
    if (!file) return;
    if (!/\.(xlsx|xlsm)$/i.test(file.name)) {
      setMessage({
        text: "El archivo debe ser un Excel (.xlsx o .xlsm).",
        severity: "warning",
      });
      setShowMessage(true);
      return;
    }
    setSubiendo(true);
    const uploadRes = await cotizador.uploadFleetXlsx({
      idGrupo: grupo,
      file,
      usuario: token.cdUsuario,
      noSolicitud: noSolicitudRecuperada,
      inicioVigencia,
    });
    if (!uploadRes.data) {
      setMessage({
        text:
          uploadRes.error?.mensaje ||
          "No fue posible cargar el archivo de cotización. Valida el archivo e intenta nuevamente.",
        severity: "error",
      });
      setShowMessage(true);
      setSubiendo(false);
      return;
    }
    setSolicitud(uploadRes.data.noSolicitud);
    onSolicitudCreada(uploadRes.data.noSolicitud);
    setArchivoNombre(file.name);
    setCotizado(false);
    setSubiendo(false);
    if (uploadRes.data.mensaje) {
      setMessage({
        text: uploadRes.data.mensaje,
        severity: "success",
      });
      setShowMessage(true);
    }
  };

  const handleCotizar = async () => {
    setCotizando(true);
    const quoteRes = await cotizador.createFleetQuote({
      requestNumber: Number(solicitud),
      username: token.cdUsuario,
      email: token.username,
      name: token.name,
    });
    if (!quoteRes.data || quoteRes.data.codigo !== 1) {
      setMessage({
        text:
          quoteRes.data?.mensaje ||
          quoteRes.error?.mensaje ||
          "El archivo fue cargado, pero no fue posible generar la cotización. Intenta nuevamente.",
        severity: "error",
      });
      setShowMessage(true);
      setCotizando(false);
      return;
    }
    setCotizando(false);
    setCotizado(true);
    onCotizado(quoteRes.data.data, solicitud);
  };

  const handleDescargar = async () => {
    const response = await cotizador.descargarCotizador({ grupo });
    if (response.error) {
      setMessage({ text: response.error, severity: "error" });
      setShowMessage(true);
    }
  };

  return (
    <Paper elevation={3} className={classes.panel}>
      <Alert severity="info" className={classes.info}>
        ¿Deseas cotizar nuevamente? Primero carga un nuevo layout de cotizador:
        el archivo ya cargado solo puede utilizarse una vez.
      </Alert>
      <div className={classes.acciones}>
        <Button
          variant="contained"
          className={clsx(classes.button, classes.accionBoton)}
          onClick={handleDescargar}
          disabled={subiendo || cotizando || cancelando}
        >
          <strong>Descargar layout de cotizador</strong>
        </Button>
        {!subiendo &&
        !cotizando &&
        !cancelando &&
        (!archivoNombre || cotizado) ? (
          <InputFiles
            accept=".xlsx,.xlsm"
            onChange={handleArchivoSeleccionado}
            style={{ display: "flex" }}
          >
            <Button
              variant="contained"
              className={clsx(classes.button, classes.accionBoton)}
            >
              <strong>Cargar layout de cotizador</strong>
            </Button>
          </InputFiles>
        ) : (
          <Button
            variant="contained"
            className={clsx(classes.button, classes.accionBoton)}
            disabled={subiendo || cotizando}
          >
            <strong>
              {subiendo || cotizando
                ? "Cargando cotización..."
                : "Cargar layout de cotizador"}
            </strong>
          </Button>
        )}
      </div>

      {archivoNombre && (
        <div className={classes.archivoCargado}>
          <Typography className={classes.label}>Archivo cargado</Typography>
          <div className={classes.archivoFila}>
            <Typography className={classes.value}>{archivoNombre}</Typography>
            <Button
              variant="contained"
              className={clsx(
                classes.button,
                classes.accionBoton,
                classes.botonCotizar
              )}
              disabled={cotizando || cancelando || cotizado}
              onClick={handleCotizar}
            >
              <strong>Cotizar</strong>
            </Button>
          </div>
        </div>
      )}

      {cotizacionData && !pasoTarifas && (
        <Fragment>
          <ResumenCotizacion
            cotizacionData={cotizacionData}
            solicitud={solicitud || noSolicitudRecuperada}
          />
          <div className={classes.accionesFinales}>
            <Button
              variant="text"
              className={classes.cancelar}
              onClick={onCancelar}
              disabled={subiendo || cotizando || cancelando}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              className={clsx(classes.button, classes.accionBoton)}
              onClick={onContinuar}
              disabled={cancelando}
            >
              <strong>Continuar</strong>
            </Button>
          </div>
        </Fragment>
      )}

      {pasoTarifas &&
        (cotizacionData || cargandoProductos || errorProductos) && (
          <TarifasSection
            productos={productos}
            cargando={cargandoProductos}
            error={errorProductos}
            onReintentar={onReintentarProductos}
            onEmitir={onEmitir}
            emitiendo={emitiendo}
            onCancelar={onCancelar}
            cancelando={cancelando}
          />
        )}

      {!cotizacionData && !cargandoProductos && !errorProductos && (
        <Button
          variant="text"
          className={classes.cancelar}
          onClick={onCancelar}
          disabled={subiendo || cotizando || cancelando}
        >
          Cancelar
        </Button>
      )}
    </Paper>
  );
};

export default EndosoPanel;
